import { createClient } from "@supabase/supabase-js";

const SUPABASE_PROJECT_URL = import.meta.env.VITE_SUPABASE_PROJECT_URL;
const SUPABASE_PUBLIC_ANON_API_KEY = import.meta.env
  .VITE_SUPABASE_PUBLIC_ANON_API_KEY;

const authOptions = {
  storageKey: `${import.meta.env.MODE}-cp-sb.auth.token`,
};

const client = createClient(
  SUPABASE_PROJECT_URL,
  SUPABASE_PUBLIC_ANON_API_KEY,
  {
    auth: authOptions,
    global: {

    }
  }
);

const getClient = () => client;

const buildClient = (headers = {}) => {
  const options = {
    auth: authOptions,
    global: {
      headers: headers,
    },
  }
  return createClient(
    SUPABASE_PROJECT_URL,
    SUPABASE_PUBLIC_ANON_API_KEY,
    options
  );
}

export { client, getClient, buildClient };

